var map = {
	"./tile-01.png": "b165",
	"./tile-02.png": "03b3",
	"./tile-03.png": "b218",
	"./tile-04.png": "4c6d",
	"./tile-05.png": "d1a7",
	"./tile-06.png": "a0a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f915";